import { InvoiceLineItem } from './invoice-lineitem.model';

export class Invoice {
  public constructor() {
    this.InvoiceNum = 0;
    this.InvoiceDate = new Date();
    this.AmountPaid = 0;
    this.ProfileId = 0;
    this.BillToName = '';
    this.BillToAddress1 = '';
    this.BillToAddress2 = '';
    this.BillToCity = '';
    this.BillToState = '';
    this.BillToZip = '';
    this.BillToZipExt = '';
    this.ShipToName = '';
    this.ShipToAddress1 = '';
    this.ShipToAddress2 = '';
    this.ShipToCity = '';
    this.ShipToState = '';
    this.ShipToZip = '';
    this.ShipToZipExt = '';
    this.Attention = '';
    this.DateDue = new Date();
    this.Terms = '';
    this.Po = '';
    this.Rep = '';
    this.ShipVia = '';
    this.DiscountType = '';
    this.DiscountAmount = 0;
    this.TaxType = '';
    this.TaxAmount = 0;
    this.ShippingCost = 0;
    this.TotalCost = 0;
    this.ReferenceNum = '';
    this.Memo = '';
    this.CustComments = '';
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.ChangedBy = '';
    this.Posted = false;
    this.DatePosted = new Date();
    this.Batch_Creation = '';
    this.Batch_Posting = '';
    this.InvoiceSent = false;
    this.DateSent = new Date();
    this.SentBy = '';
    this.CollectionRep = 0;
    this.PostedBy = '';
    this.CommunicateWithProfileID = 0;
    this.ShowMessage = false;
    this.ShowPayLink = false;
    this.DisableAccess = false;
    this.NotificationMessage = '';
    this.TrackingNumber = '';
    this.EstimatedCollectionDate = new Date();
    this.AdjustedAmountDue = 0;

    this.InvoiceLineItems = new Array<InvoiceLineItem>();
  }
  public InvoiceNum: number;
  public InvoiceDate: Date;
  public AmountPaid: number;
  public ProfileId: number;
  public BillToName: string;
  public BillToAddress1: string;
  public BillToAddress2: string;
  public BillToCity: string;
  public BillToState: string;
  public BillToZip: string;
  public BillToZipExt: string;
  public ShipToName: string;
  public ShipToAddress1: string;
  public ShipToAddress2: string;
  public ShipToCity: string;
  public ShipToState: string;
  public ShipToZip: string;
  public ShipToZipExt: string;
  public Attention: string;
  public DateDue: Date;
  public Terms: string;
  public Po: string;
  public Rep: string;
  public ShipVia: string;
  public DiscountType: string;
  public DiscountAmount: number;
  public TaxType: string;
  public TaxAmount: number;
  public ShippingCost: number;
  public TotalCost: number;
  public ReferenceNum: string;
  public Memo: string;
  public CustComments: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public ChangedBy: string;
  public Posted: boolean;
  public DatePosted: Date;
  public Batch_Creation: string;
  public Batch_Posting: string;
  public InvoiceSent: boolean;
  public DateSent: Date;
  public SentBy: string;
  public CollectionRep: number;
  public PostedBy: string;
  public CommunicateWithProfileID: number;
  public ShowMessage: boolean;
  public ShowPayLink: boolean;
  public DisableAccess: boolean;
  public NotificationMessage: string;
  public TrackingNumber: string;
  public EstimatedCollectionDate: Date;
  public AdjustedAmountDue: number;

  public InvoiceLineItems: Array<InvoiceLineItem>;
}
